import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Link from 'components/Link';
import { isDevelopment } from 'helpers/user';

interface SmsOptInModalProps {
    show: boolean;
    onClose: () => void;
    mode?: 'mfaOptOut' | 'noPasscode' | 'notifications';
}

export const SmsOptInModal: React.FC<SmsOptInModalProps> = ({
    show,
    onClose,
    mode = 'mfaOptOut',
}) => {    
    const isProd = !isDevelopment();
    const mfaPhone = isProd ? '16232639564' : '18556411775';
    const transactionalPhone = isProd ? '16232445402' : '16236248120';

    const phoneNumberMap = {
        notifications: transactionalPhone,
        mfaOptOut: mfaPhone,
        noPasscode: mfaPhone,
    };

    const phoneNumber = phoneNumberMap[mode];

    const getModalContent = (): React.ReactNode => {
        if (mode === 'notifications') {
            return (
                <div className="text-opt-in-content">
                    <p>
                        We've detected that you previously opted out to account-related updates via SMS/Text. 
                        To opt back in, send START to +{phoneNumber}. Please allow us 5 minutes to update your settings.
                    </p>
                    <p>
                        If you consent to receiving SMS/text messages related to your account from StorageTreasures.
                    </p>
                    <ul>
                        <li>Message and data rates may apply.</li>
                        <li>Reply STOP to opt out at any time.</li>
                        <li>Consent is not required to use StorageTreasures services.</li>
                        <li>
                            For more details, please review our <Link to="/terms" target="_blank">Terms of Use</Link> and <Link to="/privacy" target="_blank">Privacy Policy</Link>.
                        </li>
                    </ul>
                </div>
            );
        }

        const prefixMessages = {
            mfaOptOut: 'We\'ve detected that you previously opted out of receiving the login verification code via SMS/Text.',
            noPasscode: 'Not receiving passcode? You may have previously opted out of receiving the login verification code via SMS/Text.',
        };

        return (
            <div className="text-opt-in-content">
                <p>{prefixMessages[mode]} To opt back in, send START to +{phoneNumber}. Message and data rates may apply.</p>
                <p>Please allow us 5 minutes to update your settings before trying again. In the meantime, you can select the call option to receive your one-time passcode for logging in.</p>
            </div>
        );
    };

    return (
        <Modal
            show={show}
            onHide={onClose}
            aria-labelledby="text-opt-in-modal"
            keyboard={false}
        >
            <Modal.Header closeButton className="border-0">
                {getModalContent()}
            </Modal.Header>
        </Modal>
    );
};

export default SmsOptInModal;